<template>
  <div>
    <form class="xcard" @submit.prevent="validarCampos" style="margin-top: 0" novalidate>
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras </v-btn>
      <h3 class="text-center">Registrar Nuevo Postgrado</h3>
      <p class="text-center">
        Los postgrados creados seran visibles para las demas sedes a nivel nacional, las demas sedes pueden reusar los
        datos de este postgrado para crear sus propios programas.
      </p>
      <p class="text-center text-primary" style="margin-bottom: 0">
        <small class="center-block">
          <span class="glyphicon glyphicon-exclamation-sign"></span> Los campos con un asterisco
          <span class="text-danger">*</span> son obligatorios
        </small>
      </p>

      <p class="text-right">
        <button
          type="button"
          data-toggle="modal"
          data-target="#modal-narea"
          title="Crear Area"
          class="btn btn-sm btn-link">
          <span class="glyphicon glyphicon-plus"></span> Nueva area
        </button>
      </p>
      <div class="row">
        <div class="col-sm-6"> 
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.idcategoria') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Categoria</div>
              <Categorias :model="postgrado" /> 
            </div>
            <div class="error" v-if="validation.hasError('postgrado.idcategoria')">
              {{ validation.firstError('postgrado.idcategoria') }}
            </div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.clase_netsuite_id') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger" v-show="clasesnet.length">*</span> Clase NetSuite</div>
              <multiselect
                class="form-control"
                v-model="postgrado.clase_netsuite_id"
                :options="clasesnet"
                track-by="id"
                label="nombre"
                :disabled="clasesnet.length == 0"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                :loading="loading_clasesnet" 
                :placeholder="clasesnet.length?'Seleccione...':'No hay clases.'"/>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.clase_netsuite_id')">
              {{ validation.firstError('postgrado.clase_netsuite_id') }}
            </div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.idarea') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Area</div>
              <Areas :model="postgrado" />
            </div>
            <div class="error" v-if="validation.hasError('postgrado.idarea')">
              {{ validation.firstError('postgrado.idarea') }}
            </div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.nombre') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Nombre</div>
              <input
                type="text"
                v-model.trim="postgrado.nombre"
                class="form-control"
                placeholder="Nombre del postgrado" />
            </div>
            <div class="error" v-if="validation.hasError('postgrado.nombre')">
              {{ validation.firstError('postgrado.nombre') }}
            </div>
            <small class="purple--text"> No escriba el nombre de la categoria, el sistema lo pone automaticamente delante del nombre. </small>
          </div>
          <!-- <div class="form-group">
            <div class="input-group input-group-sm" :class="{ 'has-error': validation.hasError('postgrado.fase') }">
              <div class="input-group-addon"><span class="text-danger">* </span> Fase</div>
              <select v-model.trim="postgrado.fase" class="form-control">
                <option value="0">0 Por aprobar</option>
                <option value="1">1 Aprobado</option>
                <option value="2">2 Permitir crear programa</option>
              </select>
            </div>
            <p>
              <small> <b>NOTA:</b> Segun la fase se permiten ciertas funciones, asegurese de seleccionar bien, esta fase se puede cambiar luego. </small>
            </p>
            <div class="error" v-if="validation.hasError('postgrado.fase')">{{ validation.firstError('postgrado.fase') }}</div>
          </div> -->
          <hr />
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.creditaje') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Creditaje</div>
              <input type="text" v-model.trim="postgrado.creditaje" class="form-control" placeholder="Numero entero" />
              <span class="input-group-addon">Creditos</span>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.creditaje')">
              {{ validation.firstError('postgrado.creditaje') }}
            </div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.carga_horaria') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Carga horaria</div>
              <input
                type="text"
                v-model.trim="postgrado.carga_horaria"
                class="form-control"
                placeholder="Numero entero" />
              <span class="input-group-addon">Horas</span>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.carga_horaria')">
              {{ validation.firstError('postgrado.carga_horaria') }}
            </div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.duracion') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Duracion</div>
              <input type="text" v-model.trim="postgrado.duracion" class="form-control" placeholder="Numero entero" />
              <span class="input-group-addon"> {{ uni_dur }} </span>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.duracion')">
              {{ validation.firstError('postgrado.duracion') }}
            </div>
          </div>

          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.unidad_duracion') }">
            <div class="input-group input-group-sm">
              <div class="input-group-addon"><span class="text-danger">*</span> Unidad Duracion</div>
              <select class="form-control input-group" v-model="postgrado.unidad_duracion">
                <option value="0">Meses</option>
                <option value="1">Semanas</option>
                <option value="2">Dias</option>
                <option value="3">Horas</option>
              </select>
            </div>
            <div class="error" v-if="validation.hasError('postgrado.unidad_duracion')">
              {{ validation.firstError('postgrado.unidad_duracion') }}
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.dirigido') }">
            <label for="comment">Dirigido:</label>
            <textarea
              v-model.trim="postgrado.dirigido"
              class="form-control"
              placeholder="Texto a quien va dirigido el postgrado"
              rows="3"></textarea>
            <div class="error" v-if="validation.hasError('postgrado.dirigido')">
              {{ validation.firstError('postgrado.dirigido') }}
            </div>
          </div>
          <div class="form-group" :class="{ 'has-error': validation.hasError('postgrado.objetivo') }">
            <label for="comment">Objetivo:</label>
            <textarea
              v-model.trim="postgrado.objetivo"
              class="form-control"
              placeholder="Objetivo del postgrado"
              rows="3"></textarea>
            <div class="error" v-if="validation.hasError('postgrado.objetivo')">
              {{ validation.firstError('postgrado.objetivo') }}
            </div>
          </div>
        </div>
      </div>

      <Alertas ref="alertar" />
      <NuevaArea />
      <p class="text-center">{{ msg }}</p> 

      <button :disabled="!activo" type="submit" class="btn btn-sm btn-azul center-block">
        <span class="glyphicon glyphicon-ok"></span> Aceptar
      </button>
    </form>
    <notifications group="auth" position="bottom right" />
  </div>
</template>

<script>
  import { Validator } from 'simple-vue-validator';
  import gql from 'graphql-tag';
  import Areas from '@/components/Areas.vue';
  import Categorias from '@/components/ACategorias.vue';
  import Alertas from '@/components/AAlertas.vue';
  import NuevaArea from '@/components/ANewArea.vue';
  import xaxios from '@/xaxios';
  import { mapState } from 'vuex';
  export default {
    data() {
      return {
        permiso_add: true,
        activo: true,
        msg: '',
        universidades: [],
        postgrados: [],
        sedes: [],
        gestiones: [],
        uni_dur: '',
        loading_clasesnet: false,
        postgrado: {
          idarea: null,
          idcategoria: null,
          clase_netsuite_id: null,
          nombre: null,
          fase: 0,
          portada: 'portadita',

          creditaje: null,
          duracion: null,
          dirigido: null,
          objetivo: null,
          carga_horaria: null,
          unidad_duracion: null,
        },
        clasesnet:[],
      };
    },
    components: { Areas, Categorias, Alertas, NuevaArea },
    validators: {
      'postgrado.idarea'(value) {
        return Validator.value(value).required();
      },
      'postgrado.idcategoria'(value) {
        return Validator.value(value).required();
      },
      'postgrado.clase_netsuite_id'(value) {
        if(this.clasesnet.length > 0) return Validator.value(value).required();
        return Validator.value(value);
      },
      'postgrado.nombre'(value) {
        return Validator.value(value).required().minLength(5);
      },
      'postgrado.portada'(value) {
        return Validator.value(value).required().minLength(5);
      },
      'postgrado.fase'(value) {
        return Validator.value(value).digit().required().maxLength(1).lessThan(1);
      },
      'postgrado.creditaje'(value) {
        return Validator.value(value).integer().minLength(0).required().maxLength(4).greaterThan(-1);
      },
      'postgrado.duracion'(value) {
        return Validator.value(value).integer().minLength(1).required().maxLength(3).greaterThan(0);
      },
      'postgrado.carga_horaria'(value) {
        return Validator.value(value).integer().minLength(1).required().maxLength(5).greaterThan(0);
      },
      'postgrado.unidad_duracion'(value) {
        return Validator.value(value).integer().minLength(1).required().maxLength(5).greaterThan(-1);
      },
      'postgrado.dirigido'(value) {
        return Validator.value(value).minLength(5).maxLength(499);
      },
      'postgrado.objetivo'(value) {
        return Validator.value(value).minLength(5).maxLength(499);
      },
    },

    watch: {
      postgrado: {
        deep: true,
        handler() {
          //window.console.log( ".................... watch",JSON.stringify(this.postgrado) )
          window.sessionStorage.setItem('xpostgrado', JSON.stringify(this.postgrado));
          if (this.postgrado.unidad_duracion) {
            var u = this.postgrado.unidad_duracion;
            if (u == '0') this.uni_dur = 'Meses';
            else if (u == '1') this.uni_dur = 'Semanas';
            else if (u == '2') this.uni_dur = 'Dias';
            else if (u == '3') this.uni_dur = 'Horas';
            else this.uni_dur = '?';
          }
        },
      },
      'postgrado.idcategoria': function(){
        if(!this.postgrado.idcategoria) return;
        this.getNetSuiteClase();
      }
    },
    computed: {
      ...mapState({ UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID }),
    },
    methods: {
      validarCampos() {
        this.$validate().then((success) => {
          var obj = window.Object.assign({}, this.postgrado);
          if (obj.duracion != null) obj.duracion = window.parseInt(obj.duracion);
          if (obj.creditaje != null) obj.creditaje = window.parseFloat(obj.creditaje);
          if (obj.carga_horaria != null) obj.carga_horaria = window.parseFloat(obj.carga_horaria);
          if (obj.unidad_duracion != null) obj.unidad_duracion = window.parseInt(obj.unidad_duracion);
          if (success) {
            obj.nombre = obj.nombre.replace(obj.idcategoria.nombre, '');
            obj.nombre = obj.nombre.replace('Esam Cursos', '');
            obj.nombre = obj.nombre.replace('Diplomado en', '');
            obj.nombre = obj.nombre.replace('Maestría en', '');
            obj.nombre = obj.nombre.replace('Maestria en', '');
            obj.nombre = obj.nombre.replace('Especialidad en', '');
            obj.nombre = obj.nombre.replace('Doctorado en', '');
            obj.nombre = obj.nombre.trim();
            obj.idarea = obj.idarea.id;
            obj.idcategoria = obj.idcategoria.id;
            if(obj.clase_netsuite_id) obj.clase_netsuite_id = obj.clase_netsuite_id.id;
            // obj.clases_netsuite = obj.idcategoria.clase_netsuite_id;
            window.console.log('>>>>>>>>>>>>>>>',obj);
            // estas acciones van en par, set el objeto para luego limpiar campos nulos
            this.$store.state.obj = obj;
            this.$store.dispatch('quitarNulos');

            delete obj.fase; // todavia no esta implemetado en el server

            this.activo = false;
            this.$refs.alertar.cargando();
            this.enviarDatos(obj);
          } else {
            this.$refs.alertar.invalido();
          }
        });
      },
      async enviarDatos(obj) {
        window.console.log('posgradoooo:::',JSON.stringify(obj), '\n\n\n');
        
        
        obj.unidad_negocio_id = this.UNIDAD_NEGOCIO_ID;
        var vue = this;
        var sql = gql`mutation{ createPostgrado(input:${window.stringifyObject(obj)}){ok,errors{message}} }`;
        vue.msg = '';
        this.$apollo
          .mutate({
            mutation: sql,
          })
          .then(({ data }) => {
            // window.console.log(data);
            if (data.createPostgrado.ok) {
              vue.$refs.alertar.success();
            } else {
              var errores = JSON.stringify(data.createPostgrado.errors);
              var ob = JSON.parse(errores);
              var vals = '';
              ob.forEach(function (k) {
                vals += Object.values(k) + '-\n\t';
              });
              vue.msg = '';
              vue.activo = true;
              vue.$refs.alertar.invalido(vals);
            }
          })
          .catch((error) => {
            vue.$refs.alertar.invalido();
            this.activo = true;
            window.console.error(error);
            vue.msg = error;
          });
      },
      async getNetSuiteClase(){
        this.postgrado.clase_netsuite_id = null;
        this.clasesnet = [];
        this.loading_clasesnet = true;
        let url = process.env.VUE_APP_API_REST+`/api/v1/esam/clasesnetsuite/${this.postgrado.idcategoria.clase_netsuite_id}`
        let res = await xaxios.get(url).then(x=>x).catch(e=>e);
        let clases = res.data;
        if(!clases) clases = [];
        window.console.log('claseeee',clases);
        this.clasesnet = clases;
        this.loading_clasesnet = false;
      },
    },
    mounted() {
    },
  };
</script>
